import React, { useState } from "react";
import { apiPost, endSession } from "../Api/Client.js";

const MIN_LENGTH = 6;

// Change your own password: three boxes and a button on one line (stacked on a
// phone). The rules are shown as you type, so the button is only ever pressed
// when it can succeed. The admin "reset someone else" flow stays on its own page
// (AdminChangePasswordScreen).
export default function ChangeOwnPassword() {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  // One message at most, for the first rule not yet met -- and nothing is said
  // about a box the person has not touched yet.
  let problem = "";
  if (newPassword && newPassword.length < MIN_LENGTH) problem = `New password must be at least ${MIN_LENGTH} characters.`;
  else if (newPassword && oldPassword && newPassword === oldPassword) problem = "New password must be different from your current one.";
  else if (confirmPassword && newPassword !== confirmPassword) problem = "The two new passwords do not match.";
  const ready = oldPassword && newPassword && confirmPassword && !problem;

  const submit = async () => {
    if (!ready) return;
    setBusy(true);
    setResult(null);
    try {
      await apiPost("/Users/Auth/ChangePassword/", { old_password: oldPassword, new_password: newPassword });
      // The server has ended every session of this person, this one included; the browser keeps
      // nothing of the password (FE-02-01) and they sign in again with the new one.
      endSession();
    } catch (error) {
      setResult({ ok: false, message: error?.data?.detail || error?.message || "Update failed." });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="PProfile-Password">
      <h4>Change password</h4>
      <div className="PProfile-Password-Row">
        <label className="PProfile-Field"><span className="f-label">Current password</span>
          <input type="password" autoComplete="current-password" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} /></label>
        <label className="PProfile-Field"><span className="f-label">New password</span>
          <input type="password" autoComplete="new-password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} /></label>
        <label className="PProfile-Field"><span className="f-label">Confirm new password</span>
          <input type="password" autoComplete="new-password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} /></label>
        <button className="PProfile-Save-Btn" onClick={submit} disabled={busy || !ready}>{busy ? "Saving…" : "Update password"}</button>
      </div>
      {problem && <p className="PProfile-Password-Err">{problem}</p>}
      {result && <p className={result.ok ? "PProfile-Password-Ok" : "PProfile-Password-Err"}>{result.message}</p>}
    </div>
  );
}
